import { ref } from "vue";
import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useCountryStore = defineStore("country", () => {
  const httpStore = useHttpStore();

  const emeaCountries = ref([]);

  const getEMEACountries = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "countries/GetEMEACountries", params, { showLoading: true })
        .then((res) => {
          if (res.success) {
            emeaCountries.value = res.countries;
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getEMEACountries
  };
});
